'use client'

import { useEffect } from 'react'

export function useBootstrapTooltips() {
  useEffect(() => {
    let cancelled = false
    let tooltips: { dispose: () => void }[] = []

    // Dynamic import prevents Bootstrap JS from accessing document during SSR.
    // Awaited inside an async function rather than chained with .then() so React
    // Compiler can compile the effect, and so the load is cancellable: without
    // the guard, a component unmounted mid-import still attached tooltips to
    // detached nodes and never disposed them.
    const attach = async () => {
      const { Tooltip } = await import('bootstrap')
      if (cancelled) return

      const elements = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltips = elements.map(el => new Tooltip(el, { trigger: 'hover' }))
    }

    attach()

    return () => {
      cancelled = true
      tooltips.forEach(tooltip => tooltip.dispose())
    }
  }, [])
}
